/*
 * File: loading-block.ts
 * File Created: 2024-02-01 06:17:03
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-10-18 11:01:20
 * Modified By: Val Liu
 * -----
 */

import { BaseComponent } from "@root/components/base-classes";
import { ObjectHelper } from "@root/core";
import { IQuery, IQueryDefault } from "@root/core/server/restful";
import { Component, Emit, Prop, Watch } from "vue-property-decorator";

/// show loading when the query is not present.
@Component
export default class LoadingBlock extends BaseComponent {
    @Prop({ type: Object, default: () => IQueryDefault() })
    query!: IQuery;

    @Prop({ type: Function, required: false })
    errorHandler: { (err: any): void } | null | undefined;

    /// could make only 500 / network error show reload,
    /// the rest still showing the content, but also add $alert message.
    @Watch("query.loading")
    onLoadingUpdated() {
        this.prev_error = null;
    }
    private prev_error: any;
    get showing() {
        const { error } = this.query;
        /// no error
        if (!error) return true;
        const statusCode = error.res?.statusCode;
        if (statusCode === 500 || statusCode === undefined) return false;

        if (!ObjectHelper.equals(this.prev_error, error)) {
            this.prev_error = ObjectHelper.deepClone(error);
            this.errorHandler?.(error);
        }
        return true;
    }

    @Emit("reload")
    doReload() {
        /// default reload
        if (this.$listeners.reload == null) {
            this.query?.reload?.();
            return;
        }

        return true;
    }
}
